export const HierarchicalListQcFieldName = 'hierarchicalListQcFieldComponent';
